import {post, put} from "../util/http.service";

export const createAccount = account => post("/accounts", account);

export const updateAccount = (id, account) => put("/accounts/" + id, account);

export const updatePositions = ids => put("/accounts/positions", {ids});
